<div class="stuff">
    <h2>Kontakt</h2>
    <p>E-Mail: <a href="mailto:chequeo.app@gmail.com?subject=Kontakt chequeo.de"
            class="mail">chequeo.app&#64;gmail.com</a>
    </p>
</div>
